import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { FieldDataItem } from "../classes/field_data_item";
import FieldInfoContent from "../components/FieldInfoContent";

export interface FieldInfoDialogProps {
  open: boolean;
  onClose: () => void;
  field?: {
    id: number;
    name: string;
  } | null;
  agricultureAnalysisData?: {
    id: number;
    phase: string;
  };
  fieldDataItems?: FieldDataItem[];
  fieldBoundary?: google.maps.LatLngLiteral[];
  photogrammetry?: boolean;
}

const FieldInfoDialog = (props: FieldInfoDialogProps) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={props.open}
        onClose={() => {props.onClose()}}
        PaperProps={{
          component: 'form',
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            props.onClose();
          },
        }}
      >
        <DialogTitle>{t('Info')}</DialogTitle>
        <DialogContent>
          <FieldInfoContent
            field={props.field}
            agricultureAnalysisData={props.agricultureAnalysisData}
            fieldDataItems={props.fieldDataItems}
            fieldBoundary={props.fieldBoundary}
            photogrammetry={props.photogrammetry}
            displayMode="table"
            showAreaInfo
            showAreaName
          />
        </DialogContent>
        <DialogActions>
          <Button type="submit">{t('Ok')}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default FieldInfoDialog;
